import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle, Star, Rocket } from "lucide-react";

interface VIPUpgradeModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const VIPUpgradeModal = ({ open, onOpenChange }: VIPUpgradeModalProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl md:text-3xl font-bold text-center text-[#2e4053]">
            VIP Builder Pass
          </DialogTitle>
          <p className="text-center text-[#2e4053]/70">
            Unlock the full summit experience.
          </p>
        </DialogHeader>
        
        <div className="mt-6">
          {/* VIP Builder Pass Card */}
          <div className="relative p-8 bg-gradient-to-br from-[#1a1a2e] to-[#2e4053] rounded-2xl border-2 border-[#d8239b] text-center">
            {/* Most Popular Badge */}
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1.5 bg-gradient-to-r from-[#d8239b] to-[#ff69b4] text-white font-bold text-xs rounded-full flex items-center gap-1.5 shadow-lg">
              <Star className="w-3.5 h-3.5" />
              EXCLUSIVE ACCESS
            </div>
            
            {/* Icon */}
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#d8239b] to-[#ff69b4] flex items-center justify-center mx-auto mb-4 mt-2 shadow-lg">
              <Rocket className="w-8 h-8 text-white" />
            </div>
            
            {/* Scarcity Badge */}
            <div className="text-[#ff4444] font-bold text-sm mb-3">
              ⚠️ Only 25 seats available
            </div>
            
            <p className="text-[#ff69b4] font-bold text-2xl mb-1">$97 <span className="text-base font-normal text-white/60">One-Time</span></p>
            <p className="text-white/60 text-sm mb-6">Everything in Community Pass, plus:</p>
            
            <ul className="text-left space-y-3 mb-8">
              <li className="flex items-center gap-3 text-white/90">
                <CheckCircle className="w-5 h-5 text-[#ff69b4] flex-shrink-0" />
                <span>VIP Day 4 Included</span>
              </li>
              <li className="flex items-center gap-3 text-white/90">
                <CheckCircle className="w-5 h-5 text-[#ff69b4] flex-shrink-0" />
                <span>Lifetime Recordings</span>
              </li>
              <li className="flex items-center gap-3 text-white/90">
                <CheckCircle className="w-5 h-5 text-[#ff69b4] flex-shrink-0" />
                <span>Build Your Digital Product</span>
              </li>
              <li className="flex items-center gap-3 text-white/90">
                <CheckCircle className="w-5 h-5 text-[#ff69b4] flex-shrink-0" />
                <span>Priority Support</span>
              </li>
            </ul>
            
            <Button 
              size="lg" 
              className="w-full bg-gradient-to-r from-[#d8239b] to-[#ff69b4] hover:from-[#d8239b]/90 hover:to-[#ff69b4]/90 text-white font-bold py-6 text-lg shadow-lg"
              onClick={() => window.open('https://buy.stripe.com/dRm9ATdsrbWMd6jev45c400', '_blank')}
            >
              Upgrade to VIP
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default VIPUpgradeModal;
